import React, {useEffect} from "react";
import { NavLink } from "react-router-dom";

const Properties = () => {

    useEffect(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      return () => {};
    }, []);

  return (
    <div className="">
      <div className="page-container" id="properties">
        <section class="wrapper">
          <div class="container">
            <div class="row">
              <section class="properties-item1 anim1">
                <div class="box highlight">
                  <i class="fa fa-fast-forward"></i>
                  <div className="inner">
                    <h3>Sell/lease Faster</h3>
                    <p>
                      To sell/lease your properties faster you need to join us.
                      We have different ways to help you sell/lease your
                      property faster.{" "}
                    </p>
                  </div>
                </div>
              </section>
              <section class="properties-item2 anim2">
                <div class="box highlight">
                  <i class="fa fa-users"></i>
                  <div className="inner">
                    <h3>Sell/lease To Employees</h3>
                    <p>
                      If you join us you can sell your properties to employees
                      on credit and later to get paid within 12 months, or lease
                      to get paid monthly.{" "}
                    </p>
                  </div>
                </div>
              </section>
              <section class="properties-item3 anim3">
                <div class="box highlight">
                  <i class="fa fa-globe"></i>
                  <div className="inner">
                    <h3>Sell/Lease To Non-employees</h3>
                    <p>
                      You can also sell/lease your properties to non-employees
                      on our platform and get your money completely cash, at
                      affordable commissions.{" "}
                    </p>
                  </div>
                </div>
              </section>
            </div>
            <div className="signup-btn anim4">
              <NavLink to="/vendor-signup">
                <button className="primary-btn">Get Started</button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Properties;
